import { useTranslation } from 'react-i18next'
import Button from 'components/Button'
import { SelectedMailsButtonsWrapper } from './styles'

interface IProps {
  selectedMailsNumber: number,
  confirmText: string,
  onConfirm: () => void,
  onCancel: () => void
}

// TODO: disable button with a prop
const SelectedMailsButtons = (props: IProps) => {
  const { selectedMailsNumber, confirmText, onConfirm, onCancel } = props
  const { t } = useTranslation()

  return (
    <SelectedMailsButtonsWrapper>
      <Button onClick={onCancel} disabled={selectedMailsNumber == 0}>{t('global.cancel')}</Button>

      <span/>

      <Button onClick={onConfirm} disabled={selectedMailsNumber == 0}>
        {confirmText}{selectedMailsNumber === 0 ? '' : ` (${selectedMailsNumber})`}
      </Button>
    </SelectedMailsButtonsWrapper>
  )
}

export default SelectedMailsButtons
